import { lazyWithRetry as lazy } from "@/utils/lazyWithRetry";

export const Browse = lazy(() => import("@/Pages/Browse"));
export const Settings = lazy(() => import("@/Pages/Settings"));
export const Notifications = lazy(() => import("@/Pages/Notifications"));
export const Invitations = lazy(() => import("@/Pages/Invitations"));

// Rebel Events Components
export const MyEvents = lazy(() => import("@/Pages/MyEvents/MyEvents"));
export const HubEvent = lazy(() => import("@/Pages/Hubs/Events/HubEvent"));
export const ScoringContainer = lazy(
  () => import("@/Pages/Hubs/Events/Scoring")
);

// Rebel Projects Components
export const MyProjectBuilders = lazy(() => import("@/Pages/Project/Builders"));
export const BuilderOverview = lazy(
  () => import("@/Pages/Project/Builders/BuilderOverview")
);
export const CreateProject = lazy(
  () => import("@/Pages/Project/CreateProject")
);
export const ProjectProfile = lazy(() => import("@/Pages/Project/ProjectProfile"));
export const ProjectSettings = lazy(() => import("@/Pages/Project/Settings"));
export const BuilderTopic = lazy(
  () => import("@/Pages/Project/Builders/Builder/Topic")
);
export const BuilderIntro = lazy(
  () => import("@/Pages/Project/Builders/Builder/Intro")
);
export const BuilderReview = lazy(
  () => import("@/Pages/Project/Builders/Builder/Review")
);

// Hub Components

export const HubLibraryLayout = lazy(
  () => import("@/Pages/Hubs/HubLibrary/HubLibraryLayout")
);

export const HubMembers = lazy(() => import("@/Pages/Hubs/Members"));
export const HubManageMembers = lazy(
  () => import("@/Pages/Hubs/Members/Manage")
);
export const HubSettings = lazy(() => import("@/Pages/Hubs/HubSettings"));
export const BrainLayout = lazy(() => import("@/Pages/Hubs/Brain/BrainLayout"));
export const HubGroups = lazy(() => import("@/Pages/Hubs/Groups"));
export const HubGroupLayout = lazy(
  () => import("@/Pages/Hubs/Groups/Views/HubGroupLayout")
);
export const GroupBuilderSchedulePage = lazy(
  () => import("@/Pages/Hubs/Groups/Views/Admin/GroupBuilderSchedulePage")
);
export const HubEvents = lazy(() => import("@/Pages/Hubs/Events"));
export const CreateHubEventPage = lazy(() => import("@/Pages/Hubs/Events/CreateEvent"));
export const SingleActivity = lazy(
  () => import("@/Pages/Hubs/Activities/SingleActivity")
);
export const HubActivity = lazy(() => import("@/Pages/Hubs/Activities"));
export const HubJoinModal = lazy(() => import("@/Pages/Hubs/HubJoinModal"));
export const HubMember = lazy(() => import("@/Pages/Hubs/Members/HubMember"));
export const EditHubMembership = lazy(
  () => import("@/Pages/Hubs/Members/EditHubMembership")
);

// Auth Components
export const SignUp = lazy(() => import("@/Pages/Auth/SignUp/SignUp"));

